export default {"src":"/_next/static/media/proximite.45c94cfa.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};